import { API_ROUTES } from "../config/baseURL";
import request from "./clientsApi";
import { toast } from "react-toastify";

export const getActiveGroups = async (tipo_id, identificacion) => {
  try {
    const res = await request(API_ROUTES.getActiveGroups(tipo_id, identificacion), { method: "GET" });
    const data = await res.json();

    if (data?.success === false) {
      toast.error(data.message || "Ocurrió un error.");
      return [];
    }

    return data.data || [];
  } catch (err) {
    console.error("Error al cargar grupos activos:", err);
    return [];
  }
};

export const postActiveGroups = async (payload) => {
  try {

    if (!payload.fecha && payload.activar) {
      toast.error("Diligencie la fecha de inicio de la condicion");
      return false;
    }
    
    const res = await request(API_ROUTES.postActiveGroups, {
      method: "POST",
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (data?.success === false) {
      toast.error(data.message || "Ocurrió un error.");
      return false;
    }

    toast.success(data.message || "Registro Cargado Correctamente");;
    return true;
  } catch (err) {
    console.error("Error al guardar dirección:", err);
    throw err;
  }
};

